module.exports = __webpack_public_path__ + "static/media/coralb.c49e974c.jpg";